export const formatCalorieRange = (
  from?: number,
  to?: number
): string | undefined => {
  if (from && to) {
    return `${from}-${to} kcal`;
  }
  if (from) {
    return `${from}+ kcal`;
  }
  return undefined;
};

export const formatNutrition = (value?: number, unit = "g"): string => {
  return value ? `${Math.round(value)}${unit}` : "--";
};
